module.exports = __webpack_public_path__ + "static/media/shapes_08.1ba53f1a.svg";